/**
 * Tour steps — Integrations domain
 * Cubre: network, siem-integrations, edr, m365 (via integrations), antivirus
 */

import {
  Graph as Network,
  Database,
  Shield,
  Cloud,
  Virus
} from '@phosphor-icons/react';

// ============ NETWORK (solo full) ============
const networkProspect = {
  id: 'network',
  title: 'Mapa de tu red',
  description: 'Ve qué equipos hay en tu red, qué servicios exponen y dónde están los puntos débiles. Descubre lo que no sabías que tenías.',
  icon: Network,
  position: 'right',
  highlight: '[data-testid="nav-dropdown-infrastructure"]',
  fallbackSelector: '[href="/network"]',
  mode: 'prospect',
  length: 'full',
  domain: 'integrations',
  videoFallback: null
};

const networkOnboarding = {
  id: 'network',
  title: 'Network Discovery',
  description: 'Topología y network scanner integrado. Descubre hosts, puertos abiertos, servicios y banners. Cross-link con vulnerabilities y agents para vista completa del attack surface.',
  icon: Network,
  position: 'right',
  highlight: '[data-testid="nav-dropdown-infrastructure"]',
  fallbackSelector: '[href="/network"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'integrations',
  videoFallback: null
};

// ============ SIEM INTEGRATIONS (solo full) ============
const siemProspect = {
  id: 'siem-integrations',
  title: 'Conecta con tu SIEM actual',
  description: 'Si ya usas Splunk, Sentinel u otro, Vektor envía sus alertas directamente. No tiras tu inversión actual, la amplificas.',
  icon: Database,
  position: 'right',
  highlight: '[data-testid="nav-siem-integrations"]',
  fallbackSelector: '[href="/siem-integrations"]',
  mode: 'prospect',
  length: 'full',
  domain: 'integrations',
  videoFallback: null
};

const siemOnboarding = {
  id: 'siem-integrations',
  title: 'SIEM Connectors',
  description: 'Integraciones outbound con Splunk HEC, Microsoft Sentinel (Log Analytics) y otros. Envía alertas correlacionadas + telemetría enriquecida en formato estándar (CEF/ECS).',
  icon: Database,
  position: 'right',
  highlight: '[data-testid="nav-siem-integrations"]',
  fallbackSelector: '[href="/siem-integrations"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'integrations',
  videoFallback: null
};

// ============ EDR (solo full) ============
const edrProspect = {
  id: 'edr',
  title: 'Integra con tu antivirus avanzado',
  description: 'Si tienes EDR (CrowdStrike, Defender, SentinelOne), Vektor lo conecta y unifica las alertas en una sola pantalla.',
  icon: Shield,
  position: 'right',
  highlight: '[data-testid="nav-edr"]',
  fallbackSelector: '[href="/edr"]',
  mode: 'prospect',
  length: 'full',
  domain: 'integrations',
  videoFallback: null
};

const edrOnboarding = {
  id: 'edr',
  title: 'EDR Integration',
  description: 'Conector a EDRs (Defender ATP, CrowdStrike, SentinelOne) para ingest de alertas y telemetría. Unifica señales EDR con detecciones propias en la misma cola de alertas.',
  icon: Shield,
  position: 'right',
  highlight: '[data-testid="nav-edr"]',
  fallbackSelector: '[href="/edr"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'integrations',
  videoFallback: null
};

// ============ M365 / INTEGRATIONS (solo full) ============
const m365Prospect = {
  id: 'm365',
  title: 'Microsoft 365 vigilado',
  description: 'Conecta tu tenant de Microsoft 365 y Vektor vigila accesos sospechosos, configuraciones débiles y fugas de información en correo y SharePoint.',
  icon: Cloud,
  position: 'right',
  highlight: '[data-testid="nav-integrations"]',
  fallbackSelector: '[href="/integrations"]',
  mode: 'prospect',
  length: 'full',
  domain: 'integrations',
  videoFallback: null
};

const m365Onboarding = {
  id: 'm365',
  title: 'Cloud connectors (M365 / Azure AD)',
  description: 'Scaffold de ingest para Microsoft 365 y Azure AD (Entra ID). Sign-in logs, audit logs, OAuth grants. Modo mock actualmente, integración productiva en roadmap.',
  icon: Cloud,
  position: 'right',
  highlight: '[data-testid="nav-integrations"]',
  fallbackSelector: '[href="/integrations"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'integrations',
  videoFallback: null
};

// ============ ANTIVIRUS (solo full) ============
const antivirusProspect = {
  id: 'antivirus',
  title: 'Estado del antivirus en cada equipo',
  description: 'Comprueba de un vistazo si todos tus equipos tienen antivirus activo y actualizado. Sin sorpresas en la auditoría.',
  icon: Virus,
  position: 'right',
  highlight: '[data-testid="nav-antivirus"]',
  fallbackSelector: '[href="/antivirus"]',
  mode: 'prospect',
  length: 'full',
  domain: 'integrations',
  videoFallback: null
};

const antivirusOnboarding = {
  id: 'antivirus',
  title: 'Antivirus Status',
  description: 'Reporting de estado AV por agente (vendor, versión, definitions date, real-time protection on/off). Detecta endpoints con AV deshabilitado o desactualizado.',
  icon: Virus,
  position: 'right',
  highlight: '[data-testid="nav-antivirus"]',
  fallbackSelector: '[href="/antivirus"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'integrations',
  videoFallback: null
};

export const domainSteps = {
  prospect: {
    quick: [],
    full: [networkProspect, siemProspect, edrProspect, m365Prospect, antivirusProspect]
  },
  onboarding: {
    quick: [],
    full: [networkOnboarding, siemOnboarding, edrOnboarding, m365Onboarding, antivirusOnboarding]
  }
};
